import React from 'react';
import styles from './SegmentControl.module.css';

const SegmentControl = ({ items, activeItemId, onItemClick }) => {
  // Find the index of the active item to calculate the slider's position
  const activeIndex = items.findIndex(item => item.id === activeItemId);
  const numberOfItems = items.length;

  return (
    <div className={styles.container}>
      {/* This is the animated sliding background element with the shadow */}
      <div
        className={styles.slider}
        style={{
          // The width is now calculated based on the number of items
          width: `calc((100% - var(--spacing-xs)) / ${numberOfItems})`, 
          // The transform moves the slider to the correct position
          transform: `translateX(calc(100% * ${activeIndex}))`,
        }}
      />
      {items.map((item) => (
        <button
          key={item.id}
          className={styles.tabButton}
          onClick={() => onItemClick(item.id)}
          aria-pressed={item.id === activeItemId}
        >
          <span className={`${styles.label} ${item.id === activeItemId ? styles.activeLabel : ''}`}>
            {item.label}
          </span>
        </button>
      ))}
    </div>
  );
};

export default SegmentControl;